import styled from "styled-components";

import { colorsPalettes, setElevation } from "@similarweb/styles";
import { SearchInput } from "@similarweb/ui-components";
import { Stack } from "@similarweb/ui-components/foundations";

export const Container = styled(Stack)<{ $isOpen?: boolean }>`
    position: relative;
    z-index: 1001;
    gap: 16px;
    width: 100%;
    max-height: 112px;

    padding: 16px;
    border-radius: 6px;
    background: ${colorsPalettes.carbon[0]};

    ${({ $isOpen }) => ($isOpen ? "" : setElevation("Z1"))};

    .SearchAutocompleteWithTabs {
        height: auto;

        .AutoCompleteContainer {
            height: auto;
            /* Override Autocomplete's own border/shadow so the panel looks unified */
            border: none;
            box-shadow: none;
        }
    }
`;

/**
 * Wraps both the autocomplete panel and the bot strip so they are
 * transformed and visually framed together.
 */
export const SearchPanelWrapper = styled.div`
    transform: translate(-16px, -109px);
    width: calc(100% + 32px);
    display: flex;
    flex-direction: column;
    ${setElevation("Z3")};
    border-radius: 6px;
    overflow: hidden;
`;

export const StyledSearchInput = styled(SearchInput)<{ $isOpen?: boolean }>`
    width: calc(100% - 10px);
    margin-bottom: 0;
    height: 40px;
    ${({ $isOpen }) => ($isOpen ? "visibility: hidden;" : "")}
`;
